import { EMPTY_LIST } from '../../../constants/common'
import { EntityActionTypeSelectOptionValue } from '../../Entity'

export const QA_NAME_CLEAR_ALL = 'clearAll'

export const QA_NAME_EDIT_ADDRESS = 'EditAddress'

export const USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING = 'building'

export const USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS = 'addedFlats'

export const USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS =
  'selectedFlats'

export const USER_EDIT_ADDRESS_FORM_MODAL_REQUIRED_FLATS_FIELD_WHEN_BUILDING_SELECTED =
  'required-flats-field-when-building-selected'

export const USER_EDIT_ADDRESS_FORM_MODAL_INITIAL_VALUES = {
  [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS]: EMPTY_LIST,
  [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_BUILDING]: null,
  [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_SELECTED_FLATS]: EMPTY_LIST,
}

export const ITEM_ACTION_TYPES = [
  EntityActionTypeSelectOptionValue.Edit,
  EntityActionTypeSelectOptionValue.RemoveAll,
]
